import React from 'react';
const Restaurants = () => <div className="service-page"><h1>Restaurants</h1><p>Discover the best restaurants and dining experiences.</p></div>;
export default Restaurants;
